import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useStockRollStore } from "../../../store/stockrollStore";
import { toast } from "react-toastify";

interface StockRollDialogProps {
    isOpen: boolean;
    onClose: () => void;
    roll: any | null;
    onSave: () => void;
}

export const StockRollDialog: React.FC<StockRollDialogProps> = ({
    isOpen, onClose, roll, onSave
}) => {
    const rollStore = useStockRollStore();
    const [formData, setFormData] = useState({
        barcode: "",
        currentQuantity: 0,
        rollCode: ""
    });
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (roll) {
            setFormData({
                barcode: roll.barcode || "",
                currentQuantity: roll.currentQuantity || 0,
                rollCode: roll.rollCode || ""
            });
        } else {
            setFormData({ barcode: "", currentQuantity: 0, rollCode: "" });
        }
    }, [roll, isOpen]);

    const handleSubmit = async () => {
        if (!roll) return;
        setSaving(true);
        try {
            await rollStore.updateItem(roll.id, {
                barcode: formData.barcode,
                currentQuantity: formData.currentQuantity,
                rollCode: formData.rollCode
            });
            toast.success("Top güncellendi!");
            onSave();
            onClose();
        } catch (error: any) {
            toast.error(error.message || "Hata oluştu");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog
            visible={isOpen}
            onHide={onClose}
            header="Top (Rulo) Düzenle"
            className="w-full sm:w-[400px]"
            modal
        >
            <div className="flex flex-col gap-4 mt-2">
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold">Barkod</label>
                    <InputText 
                        value={formData.barcode} 
                        onChange={(e) => setFormData(p => ({...p, barcode: e.target.value}))} 
                    />
                </div>
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold">Top Kodu</label>
                    <InputText 
                        value={formData.rollCode} 
                        onChange={(e) => setFormData(p => ({...p, rollCode: e.target.value}))} 
                    />
                </div>
                <div className="flex flex-col gap-2">
                    <label className="text-sm font-semibold">Mevcut Miktar</label>
                    <InputNumber 
                        value={formData.currentQuantity} 
                        onValueChange={(e) => setFormData(p => ({...p, currentQuantity: e.value || 0}))} 
                    />
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button label="İptal" className="p-button-text" onClick={onClose} />
                    <Button label="Kaydet" onClick={handleSubmit} loading={saving} className="bg-[var(--primary)] text-white" />
                </div>
            </div>
        </Dialog>
    );
};
